import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import api from '../../configs/api';

class ResetPassword extends Component {
  constructor() {
    super();

    this.state = {
      password: '',
      passwordConfirm: '',
      fail: false,
      failCode: null,
      failMessage: '',
      success: false,
    };
  }

  handleChange(field, e) {
    this.setState({
      [field]: e.target.value,
    });
  }

  submitForm(e) {
    e.preventDefault();

    api.resetPassword(this.props.match.params.token, this.state.password).then(
      () => {
        this.setState({
          success: true,
        });
      },
      response => {
        this.setState({
          fail: true,
          failCode: response.status,
          failMessage: response.body
        });
      }
    )
  }

  reset() {
    this.setState({
      password: '',
      passwordConfirm: '',
      fail: false,
      success: false
    });
  }

  render() {
    const { password, passwordConfirm } = this.state;


    const validation = {
      min8Characters: password.length >= 8,
      containsUpperCase: /[A-Z]/.test(password),
      containsLowerCase: /[a-z]/.test(password),
      containsNumber: /\d/.test(password),
      containsSpecialCharacter: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
      match: password === passwordConfirm
    };

    const allValid = validation.min8Characters && validation.containsUpperCase && 
      validation.containsLowerCase && validation.containsNumber &&
      validation.containsSpecialCharacter && validation.match;

    return (
      <div>
        <div className='header_sub'>
          <p>Password Reset - User Verified</p>
        </div>

        {!this.state.success && !this.state.fail && <div className='content'>
          <div className='container'>
            <div className='message'>
              <h2>Password Reset for ISAAC</h2>
              <p>Please enter and confirm your new password. It must be:</p>
              <ul>
                <li className={validation.min8Characters ? 'ok' : 'error'}>A minimum of 8 characters</li>
                <li className={validation.containsUpperCase ? 'ok' : 'error'}>Contain at least 1 uppercase character</li>
                <li className={validation.containsLowerCase ? 'ok' : 'error'}>Contain at least 1 lower case character</li>
                <li className={validation.containsNumber ? 'ok' : 'error'}>Contain at least 1 number</li>
                <li className={validation.containsSpecialCharacter ? 'ok' : 'error'}>Contain at least 1 special character</li>
              </ul>
              <form className='left' onSubmit={this.submitForm.bind(this)} noValidate>
                <label >Password</label>
                <input
                  value={password}
                  type='password'
                  placeholder='password'
                  onChange={this.handleChange.bind(this, 'password')} />
                <label >Confirm Password</label>
                <input
                  value={passwordConfirm}
                  type='password'
                  placeholder='confirm password'
                  onChange={this.handleChange.bind(this, 'passwordConfirm')} />
                {!validation.match && <p className='error'>Passwords must match</p>}
                <input
                  type='submit'
                  disabled={!allValid}
                  title='Submit' />
              </form>
            </div>
          </div>
        </div>}

        {this.state.fail && <div className='content'>
          <div className='container'>
            <div className='message'>
              <h2 className='error'>Error</h2>
              {
                this.state.failCode === 404 &&
                <div>
                  <p><strong>Token is epxired. Please start the process again.</strong></p>
                  <Link to="/">Start</Link>
                </div>
              }
              {
                this.state.failCode > 499 &&
                <div>
                  <p><strong>There was an error updating your password. Please try again.</strong></p>
                  <p>{this.state.failMessage}</p>
                  <button type="submit" onClick={this.reset.bind(this)}>Back</button>
                </div>
              }
            </div>
          </div>
        </div>}


        {this.state.success && <div className='content'>
          <div className='container'>
            <div className='message'>
              <h2>Success.</h2>
              <p><strong>Your password has been successfully changed.</strong></p>
              <p>You can now log onto <a href="https://isaac.wmg.com/app/">ISAAC</a> with your new password.</p>
            </div>
          </div>
        </div>}
      </div>
    );
  }
}

export default ResetPassword;
